import { css } from 'styled-components'
import { radius } from '../spacing'
import {
  fontFamilies,
  fontSizes,
  fontWeights,
  lineHeights,
} from '../typography'

export const card = css`
  border-radius: ${radius.md};
`

const singleLine = css`
  font-family: ${fontFamilies['apercu-pro']};
  font-weight: ${fontWeights.regular};
  line-height: ${lineHeights[24]};
  font-size: ${fontSizes[16]};
  letter-spacing: 0;
  text-decoration: none;
  text-transform: none;
`

const smallSingleLine = css`
  font-family: ${fontFamilies['apercu-pro']};
  font-weight: ${fontWeights.regular};
  line-height: ${lineHeights[16]};
  font-size: ${fontSizes[12]};
  letter-spacing: 0;
  text-decoration: none;
  text-transform: none;
`

const strongSingleLine = css`
  font-family: ${fontFamilies['apercu-pro-bold']};
  font-weight: ${fontWeights.bold};
  line-height: ${lineHeights[24]};
  font-size: ${fontSizes[18]};
  letter-spacing: 0;
  text-decoration: none;
  text-transform: none;
`

const smallStrongSingleLine = css`
  font-family: ${fontFamilies['apercu-pro-bold']};
  font-weight: ${fontWeights.bold};
  line-height: ${lineHeights[16]};
  font-size: ${fontSizes[14]};
  letter-spacing: 0;
  text-decoration: none;
  text-transform: none;
`

const pressedSingleLine = css`
  font-family: ${fontFamilies['apercu-pro']};
  font-weight: ${fontWeights.regular};
  line-height: ${lineHeights[24]};
  font-size: ${fontSizes[18]};
  letter-spacing: 0;
  text-decoration: underline;
  text-transform: none;
`

const smallPressedSingleLine = css`
  font-family: ${fontFamilies['apercu-pro']};
  font-weight: ${fontWeights.regular};
  line-height: ${lineHeights[16]};
  font-size: ${fontSizes[14]};
  letter-spacing: 0;
  text-decoration: underline;
  text-transform: none;
`

export const typography = {
  singleLine,
  smallSingleLine,
  strongSingleLine,
  smallStrongSingleLine,
  pressedSingleLine,
  smallPressedSingleLine,
}
